import React from 'react'
import { Heading, Spacer, Text } from '@babylon/web-platform-ui'

interface Props {
  pageTitle?: string
  content?: string[]
  noSpaceAfterContent?: Boolean
  dynamicClassName?: string
}

const SimpleStepperTitle = ({
  pageTitle,
  content,
  noSpaceAfterContent,
  dynamicClassName,
}: Props) => (
  <div className={dynamicClassName}>
    <Heading as="h1" size="lg" data-testid="pageTitle">
      {pageTitle}
    </Heading>
    <Spacer pb={5} />
    {content?.map((text) => (
      <>
        <Text key={text}>{text}</Text>
        {!noSpaceAfterContent && <Spacer pb={9} />}
      </>
    ))}
  </div>
)

export default SimpleStepperTitle
